import { BaseSplide } from '@inc/BaseSplide';

export class RecruitCultureSplide extends BaseSplide {
  constructor(selector) {
    super(selector, {
      type: 'loop',
      // speed: 400,
      perPage: 1,
      perMove: 1,
      autoplay: true,
      focus: 'center',
      pagination: true,
      isNavigation: true,
      arrows: true,
      // gap: '3.125%',
      // padding: '19.792%',
      // breakpoints: {
      //   960: {
      //     perPage: 1,
      //     gap: '6.666%',
      //     padding: '13.86%',
      //   },
      // }
    });
  }

  init() {
    super.init();
  }

  // addOddEvenClasses() {
  //   const slides = this.splide.Components.Slides.get(false);

  //   slides.forEach((slideObj, index) => {
  //     const slideElement = slideObj.slide;
  //     slideElement.classList.add(index % 2 === 0 ? 'is-even' : 'is-odd');
  //   });
  // }

  // bindEvents() {
  //   this.splide.on('ready', () => {
  //     this.addOddEvenClasses();

  //     const splideElement = this.splide.root;
  //     const firstSlideIndex = this.splide.index;
  //     splideElement.classList.add(`slide-${firstSlideIndex + 1}`);
  //   });

  //   this.splide.on('updated', () => {
  //     this.addOddEvenClasses();
  //   });

  //   this.splide.on('move', () => {
  //     const splideElement = this.splide.root;
  //     const currentClass = Array.from(splideElement.classList).find((className) =>
  //       className.startsWith('slide-')
  //     );

  //     if (currentClass) {
  //       splideElement.classList.remove(currentClass);
  //     }
  //   });

  //   this.splide.on('moved', (newIndex) => {
  //     const slideObjs = this.splide.Components.Slides.get(false);  // Include cloned slides

  //     slideObjs.forEach((slideObj, index) => {
  //       const slide = slideObj.slide; // Get the actual slide element
  //       Array.from(slide.classList).forEach(className => {
  //         if (className.startsWith('slide-') || className === 'is-odd' || className === 'is-even') {
  //           slide.classList.remove(className);
  //         }
  //       });

  //       const relativeIndex = index - newIndex;
  //       if (relativeIndex % 2 === 0) {
  //         slide.classList.add('is-even');
  //       } else {
  //         slide.classList.add('is-odd');
  //       }
  //     });

  //     this.splide.root.classList.add(`slide-${newIndex + 1}`);
  //   });

  // }
}
